export default "__VITE_ASSET__BH3Q4_dK__"